/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/calendar-lightblue': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M23 3h-5V1a1 1 0 00-2 0v2H8V1a1 1 0 00-2 0v2H1a1 1 0 00-1 1v18a1 1 0 001 1h22a1 1 0 001-1V4a1 1 0 00-1-1zm-1 18H2V7h20z" _fill="#0073E6"/>'
  }
})
